exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-shipment[data-v-3ff51046] {\n  display: inline;\n}\n", ""]);

// exports
